import {CircularProgress} from '@mui/material';
import React from 'react'
import {Button as MuiButton} from "@mui/material";

export default function Button({isLoading, loaderProps, ...props}) {
  return (<MuiButton {...props}>
    {isLoading ? <CircularProgress size={22} color="inherit" {...loaderProps} /> : props.children}
  </MuiButton>)
}
